export default __webpack_public_path__ + "static/media/hospital.b70c370c.png";